module.exports = __webpack_public_path__ + "static/media/First Crush-01.c3786df0.svg";